import 'css-chunk:src/app/containers/Projects/AutomationConfig/AutomationConfig.scss';export default {
  "automationNodesContainer": "_automationNodesContainer_e3c0k_1",
  "automationNodeContainer": "_automationNodeContainer_e3c0k_5",
  "automationNodeOnFocus": "_automationNodeOnFocus_e3c0k_16"
};